import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/lib/axios"; // global axios config (cookies + refresh interceptor)
import LandingPage from "@/pages/LandingPage";
import HowItWorks from "@/pages/HowItWorks";
import Setup from "@/pages/Setup";
import Success from "@/pages/Success";
import PricingPage from "@/pages/PricingPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ProDashboard from "@/pages/ProDashboard";
import ScrollToTop from "@/components/ScrollToTop";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

function App() {
  return (
    <>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/setup" element={<Setup />} />
          <Route path="/success" element={<Success />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/pro-dashboard" element={<ProDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </>
  );
}

export default App;